import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Ecoomerce Redux States
import {
  GET_PRODUCTS,
  DELETE_PRODUCT,
} from "./actionType";

import {
  ecommerceApiResponseSuccess,
  ecommerceApiResponseError,
  deleteProductSuccess,
  deleteProductFail
} from "./action";
import { deleteProduct, getProductsApi } from "../../helpers/product_helper";

function* getProducts({ payload: params }) {
  try {
    const response = yield call(getProductsApi, { 'params': params});
    yield put(ecommerceApiResponseSuccess(GET_PRODUCTS, response));
  } catch (error) {
    yield put(ecommerceApiResponseError(GET_PRODUCTS, error));
  }
}


function* deleteProducts({ payload: product }) {
  try {
    const response = yield call(deleteProduct, product);
    // console.log("response", response);
    yield put(deleteProductSuccess(response));
  } catch (error) {
    yield put(deleteProductFail(error));
  }
}

export function* watchGetProducts() {
  yield takeEvery(GET_PRODUCTS, getProducts);
}

export function* watchDeleteProducts() {
  yield takeEvery(DELETE_PRODUCT, deleteProducts);
}


function* storeSaga() {
  yield all([
    fork(watchGetProducts),
    fork(watchDeleteProducts),
  ]);
}

export default storeSaga;
